import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation AchievementSetIndex($uid: String!, $index: Int!){
        achievement_set_index (uid: $uid, index: $index) {
            success
        }
    }
`;

export async function achievementSetIndex(uid: string, index: number): Promise<{ success: boolean }> {
    const result: FetchResult<{ achievement_set_index: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid, index },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.achievement_set_index;
}
